// 事件名枚举
export const Events = {
  // 自动采集
  SESSION_START: 'session_start',
  SESSION_END: 'session_end',
  PAGE_VIEW: 'page_view',
  PAGE_LEAVE: 'page_leave',
  HEARTBEAT: 'heartbeat',

  // 声明式
  BTN_CLICK: 'btn_click',
  ELEMENT_EXPOSURE: 'element_exposure',

  // 手动 - 数据集
  DATASET_SEARCH: 'dataset_search',
  DATASET_FILTER_APPLY: 'dataset_filter_apply',
  DATASET_DETAIL_VIEW: 'dataset_detail_view',
  DATASET_ADD_WORKSPACE: 'dataset_add_workspace',

  // 手动 - AI
  AI_CHAT_MESSAGE_SENT: 'ai_chat_message_sent',
  AI_CHAT_RESPONSE_RECEIVED: 'ai_chat_response_received',
  AI_SUGGESTION_CLICK: 'ai_suggestion_click',

  // 手动 - 支付
  PAYMENT_PACKAGE_SELECT: 'payment_package_select',
  PAYMENT_ORDER_CREATED: 'payment_order_created',
  PAYMENT_SUCCESS: 'payment_success',
  PAYMENT_FAIL: 'payment_fail',

  // 手动 - 用户
  LOGIN_ATTEMPT: 'login_attempt',
  LOGIN_SUCCESS: 'login_success',
  LOGIN_FAIL: 'login_fail',
  REGISTER_SUCCESS: 'register_success',
  ONBOARDING_COMPLETE: 'onboarding_complete',
  IDENTITY_SWITCH: 'identity_switch',

  // 组合式函数
  DIALOG_CLOSE: 'dialog_close',
  FORM_TIMING: 'form_timing',
}

// 事件类别
export const Category = {
  AUTO: 'auto',
  SEMI: 'semi',
  MANUAL: 'manual',
}

// SDK 配置
export const Config = {
  BATCH_SIZE: 10,
  FLUSH_INTERVAL: 5000,
  MAX_EVENTS_PER_MINUTE: 100,
  SESSION_TIMEOUT: 30 * 60 * 1000,
  HEARTBEAT_INTERVAL: 60 * 1000,
  TRACK_ENDPOINT: '/api/track/batch',
}
